import { render, staticRenderFns } from "./message-list-expandable.vue?vue&type=template&id=40088c37"
import script from "./message-list-expandable.vue?vue&type=script&lang=js"
export * from "./message-list-expandable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports